import { parseFromStripe } from "./parseFromStripe";

const today = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 0,
    amount_paid: 0,
    amount_remaining: 0,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1695005011,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [
        {
            id: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            object: "tax_rate",
            active: true,
            country: "MY",
            created: 1693369528,
            description: "SST",
            display_name: "Sales tax",
            effective_percentage: 6.0,
            inclusive: false,
            jurisdiction: null,
            livemode: false,
            metadata: {},
            percentage: 6.0,
            state: null,
            tax_type: null,
        },
    ],
    description: null,
    discount: {
        id: "di_1NrXQtGSTSE9ZxBoJbOKjqSa",
        object: "discount",
        checkout_session: null,
        coupon: {
            id: "JhUx8mKF",
            object: "coupon",
            amount_off: null,
            created: 1692949620,
            currency: null,
            duration: "once",
            duration_in_months: null,
            livemode: false,
            max_redemptions: null,
            metadata: {},
            name: "GROWTH31",
            percent_off: 31.0,
            redeem_by: null,
            times_redeemed: 0,
            valid: true,
        },
        customer: "cus_OXR6bokjAgeGq1",
        end: null,
        invoice: null,
        invoice_item: null,
        promotion_code: null,
        start: 1695005011,
        subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    },
    discounts: [
        "di_1NrXQtGSTSE9ZxBoJbOKjqSa",
    ],
    due_date: null,
    effective_at: null,
    ending_balance: -4389,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_1548cdGSTSE9ZxBo847c75ea",
                object: "line_item",
                amount: -2140,
                amount_excluding_tax: -2140,
                currency: "myr",
                description: "Unused time on Subscription (Monthly) after 18 Sep 2023",
                discount_amounts: [
                    {
                        amount: 0,
                        discount: "di_1NrXQtGSTSE9ZxBoJbOKjqSa",
                    },
                ],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1NrXQtGSTSE9ZxBo8VsDGkhi",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1695005011,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 5900,
                    amount_decimal: "5900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "inclusive",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 5900,
                    unit_amount_decimal: "5900",
                },
                proration: true,
                proration_details: {
                    credited_items: {
                        invoice: "in_1NkNMiGSTSE9ZxBoFc7Ff9ld",
                        invoice_line_items: [
                            "il_1NkNMiGSTSE9ZxBoSy2zspKO",
                        ],
                    },
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OXSHx7ZMeCK8Mf",
                tax_amounts: [
                    {
                        amount: -128,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: -2140,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "-2140",
            },
            {
                id: "il_tmp_12fdbeGSTSE9ZxBo4872ffce",
                object: "line_item",
                amount: 0,
                amount_excluding_tax: 0,
                currency: "myr",
                description: "1 × Subscription (Yearly) (at RM0.00 / year)",
                discount_amounts: [
                    {
                        amount: 0,
                        discount: "di_1NrXQtGSTSE9ZxBoJbOKjqSa",
                    },
                ],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1726627411,
                    start: 1695005011,
                },
                plan: {
                    id: "price_1NrXQtGSTSE9ZxBoXO8qZM98",
                    object: "plan",
                    active: false,
                    aggregate_usage: null,
                    amount: 0,
                    amount_decimal: "0",
                    billing_scheme: "per_unit",
                    created: 1695005011,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_MGzJfZXz64Daac",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NrXQtGSTSE9ZxBoXO8qZM98",
                    object: "price",
                    active: false,
                    billing_scheme: "per_unit",
                    created: 1695005011,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_MGzJfZXz64Daac",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 0,
                    unit_amount_decimal: "0",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_Oer9HbN1xRVsLw",
                tax_amounts: [
                    {
                        amount: 0,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 0,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "0",
            },
        ],
        has_more: false,
        total_count: 2,
        url: "/v1/invoices/upcoming/lines?coupon=JhUx8mKF&subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_proration_behavior=always_invoice&subscription_default_tax_rates%5B%5D=txr_1Nkfy8GSTSE9ZxBoFANix2G3&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice_data%5D%5Btax_behavior%5D=unspecified&subscription_items%5B1%5D%5Bprice_data%5D%5Brecurring%5D%5Binterval%5D=year&subscription_items%5B1%5D%5Bprice_data%5D%5Brecurring%5D%5Binterval_count%5D=1&subscription_items%5B1%5D%5Bprice_data%5D%5Bproduct%5D=prod_MGzJfZXz64Daac&subscription_items%5B1%5D%5Bprice_data%5D%5Bcurrency%5D=myr&subscription_items%5B1%5D%5Bprice_data%5D%5Bunit_amount_decimal%5D=0&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1695005011,
    period_start: 1695005011,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: -2121,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1695005011,
    subtotal: -2140,
    subtotal_excluding_tax: -2140,
    tax: -128,
    test_clock: null,
    total: -2268,
    total_discount_amounts: [
        {
            amount: 0,
            discount: "di_1NrXQtGSTSE9ZxBoJbOKjqSa",
        },
    ],
    total_excluding_tax: -2140,
    total_tax_amounts: [
        {
            amount: -128,
            inclusive: false,
            tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            taxability_reason: null,
            taxable_amount: -2140,
        },
    ],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const nextNoProration = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 0,
    amount_paid: 0,
    amount_remaining: 0,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1695005034,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [
        {
            id: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            object: "tax_rate",
            active: true,
            country: "MY",
            created: 1693369528,
            description: "SST",
            display_name: "Sales tax",
            effective_percentage: 6.0,
            inclusive: false,
            jurisdiction: null,
            livemode: false,
            metadata: {},
            percentage: 6.0,
            state: null,
            tax_type: null,
        },
    ],
    description: null,
    discount: {
        id: "di_1NrXRGGSTSE9ZxBoRCacKl1H",
        object: "discount",
        checkout_session: null,
        coupon: {
            id: "JhUx8mKF",
            object: "coupon",
            amount_off: null,
            created: 1692949620,
            currency: null,
            duration: "once",
            duration_in_months: null,
            livemode: false,
            max_redemptions: null,
            metadata: {},
            name: "GROWTH31",
            percent_off: 31.0,
            redeem_by: null,
            times_redeemed: 0,
            valid: true,
        },
        customer: "cus_OXR6bokjAgeGq1",
        end: null,
        invoice: null,
        invoice_item: null,
        promotion_code: null,
        start: 1695005034,
        subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    },
    discounts: [
        "di_1NrXRGGSTSE9ZxBoRCacKl1H",
    ],
    due_date: null,
    effective_at: null,
    ending_balance: -2121,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_114f68GSTSE9ZxBo3429c231",
                object: "line_item",
                amount: 0,
                amount_excluding_tax: 0,
                currency: "myr",
                description: "1 × Subscription (Yearly) (at RM0.00 / year)",
                discount_amounts: [
                    {
                        amount: 0,
                        discount: "di_1NrXRGGSTSE9ZxBoRCacKl1H",
                    },
                ],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1726627434,
                    start: 1695005034,
                },
                plan: {
                    id: "price_1NrXRGGSTSE9ZxBoxTv1Lxda",
                    object: "plan",
                    active: false,
                    aggregate_usage: null,
                    amount: 0,
                    amount_decimal: "0",
                    billing_scheme: "per_unit",
                    created: 1695005034,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_MGzJfZXz64Daac",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NrXRGGSTSE9ZxBoxTv1Lxda",
                    object: "price",
                    active: false,
                    billing_scheme: "per_unit",
                    created: 1695005034,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_MGzJfZXz64Daac",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 0,
                    unit_amount_decimal: "0",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_Oer9LjkIpu7Skt",
                tax_amounts: [
                    {
                        amount: 0,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 0,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "0",
            },
        ],
        has_more: false,
        total_count: 1,
        url: "/v1/invoices/upcoming/lines?subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice_data%5D%5Btax_behavior%5D=unspecified&subscription_items%5B1%5D%5Bprice_data%5D%5Brecurring%5D%5Binterval%5D=year&subscription_items%5B1%5D%5Bprice_data%5D%5Brecurring%5D%5Binterval_count%5D=1&subscription_items%5B1%5D%5Bprice_data%5D%5Bproduct%5D=prod_MGzJfZXz64Daac&subscription_items%5B1%5D%5Bprice_data%5D%5Bcurrency%5D=myr&subscription_items%5B1%5D%5Bprice_data%5D%5Bunit_amount_decimal%5D=0&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_default_tax_rates%5B%5D=txr_1Nkfy8GSTSE9ZxBoFANix2G3&subscription_proration_behavior=none&coupon=JhUx8mKF&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1695005034,
    period_start: 1695005034,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: -2121,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1695005034,
    subtotal: 0,
    subtotal_excluding_tax: 0,
    tax: 0,
    test_clock: null,
    total: 0,
    total_discount_amounts: [
        {
            amount: 0,
            discount: "di_1NrXRGGSTSE9ZxBoRCacKl1H",
        },
    ],
    total_excluding_tax: 0,
    total_tax_amounts: [
        {
            amount: 0,
            inclusive: false,
            tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            taxability_reason: null,
            taxable_amount: 0,
        },
    ],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const DiffCycleDowngrade = parseFromStripe(today);
const DiffCycleNoProration = parseFromStripe(nextNoProration);

export const DiffCycleMonthToYearDowngradeExpected = {
    today: DiffCycleDowngrade,
    next: DiffCycleNoProration,
};
